import { render } from "./InstruccionesActivacion.vue?vue&type=template&id=551488ce&scoped=true"
import script from "./InstruccionesActivacion.vue?vue&type=script&lang=js"
export * from "./InstruccionesActivacion.vue?vue&type=script&lang=js"

import "./InstruccionesActivacion.vue?vue&type=style&index=0&id=551488ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551488ce"]])

export default __exports__